import { getDefaultTimezone } from 'app/project/selectors';
import { connect } from 'react-redux';
import type { AppState } from '../../../app-state';
import DateString from './date-string';

export type DateStringStateProps = {
  defaultTimezone: string;
};

export const mapStateToProps = (state: AppState): DateStringStateProps => {
  return {
    defaultTimezone: getDefaultTimezone(state)
  };
};

export default connect(mapStateToProps)(DateString);
